import React from "react";
import { PageIntro, SectionCard } from "../../components/goldbot/GoldBotCards";
import {
  buildEventRows,
  getEventStreamState,
} from "../../components/goldbot/goldBotEventViewModel";
import { useGoldBotEvents } from "../../hooks/useGoldBotEvents";

function GoldBotLogs() {
  const { data, error, isLoading } = useGoldBotEvents();
  const state = getEventStreamState({ data, error, isLoading });
  const events = data && !error ? buildEventRows(data.events) : [];

  return (
    <>
      <PageIntro eyebrow="System events" title="Recent Logs" description="A chronological view of trading engine and terminal activity." />
      <SectionCard title="Event Stream" eyebrow={state.eyebrow}>
        <div className="goldbot-logs goldbot-logs--full" aria-live="polite">
          {state.message ? (
            <p className="goldbot-empty">{state.message}</p>
          ) : (
            events.map((event) => (
              <div className="goldbot-log" key={event.id}>
                <time>{event.time}</time><span className={`goldbot-log__type is-${event.type}`}>{event.type}</span><p>{event.message}</p>
              </div>
            ))
          )}
        </div>
      </SectionCard>
    </>
  );
}

export default GoldBotLogs;
